import { enumElementDrawStates, enumPanelBorderStyle, kOCNTextColor } from "../constants";
import { QStaticText } from "./QStaticText";

export class QSpacingText extends QStaticText {
  constructor() {
    super();
    this.fValue = null;
  }

  InitSpacingText(initialSpacing) {
    this.fValue = initialSpacing;
    this.InitStaticText();
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);
    this.SetBorderThickness(1);
    this.SetBorderColor("#999999");
    this.SetFillColor("#FFFFFF");

    this.SetPadding(2);

    this.SetFontSize(9);
    this.SetTextColor(this.fTextColor);
  }

  GetValue() {
    return this.fValue;
  }

  SetValue(value) {
    this.fValue = value;
  }

  GetLabel() {
    var mapping = null;
    var parentControl = this["parentctrl"];
    if (parentControl != null) mapping = parentControl.GetMapping();

    if (mapping == null) return this.fValue;
    else return mapping[this.fValue - 1];
  }

  DoSetEnabled(enabled) {
    if (enabled) this.SetBorderColor(kOCNTextColor);
    else this.SetBorderColor("#DDDDDD");
  }

  DoRenderElement(drawBuffer) {
    var txtFillStyle = this.fTextColor;

    var ctx = drawBuffer.getContext("2d");

    var fillStyle = null;
    var dState = this.GetDrawState();

    var adj = 1;
    var sx = this.fHorzOffset - adj;
    var sy = this.fVertOffset - adj;
    var sw = this.fWidth + adj * 2;
    var sh = this.fHeight + adj * 2;

    if (dState == enumElementDrawStates.Std) {
      ctx.fillStyle = "#FFFFFF";
    } else {
      var gradient = ctx.createLinearGradient(0, sy, 0, sy + sw);
      if (dState == enumElementDrawStates.MouseDown) {
        gradient.addColorStop(0, "#FFDB9F");
        gradient.addColorStop(1, "#FFC533");
      } else {
        gradient.addColorStop(0, "#FFECDA");
        gradient.addColorStop(1, "#FFDDB8");
      }
      ctx.fillStyle = gradient;
    }

    ctx.fillRect(sx, sy, sw, sh);

    this.RenderText(drawBuffer, txtFillStyle);
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var panelHandled = true;
    var wsMgr = aCmd.GetWSMgr();

    switch (cmdCode) {
      case "typespacing":
        console.log("dosomething");
        break;
      default:
        panelHandled = false;
        break;
    }

    return panelHandled;
  }
}
